import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ConsoleContextService } from '@core/services/console-context.service';
import { TenantPagination } from '@shared/components/tenant-picker/tenant-pagination';
import { TenantDto } from '@stores/tenants';
import { IconComponent } from '@shared/icons/icon/icon.component';

@Component({
  selector: 'mtm-tenant-selector',
  standalone: true,
  imports: [IconComponent, TranslatePipe],
  templateUrl: './tenant-selector.component.html',
  styleUrl: './tenant-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantSelectorComponent {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  readonly context = inject(ConsoleContextService);

  readonly isOpen = signal(false);

  readonly selected = computed(() => this.context.selectedTenant());
  // Subscriptions are needed to select a tenant's first subscription on pick.
  readonly pagination = new TenantPagination({ includeSubscriptions: true });

  toggleOpen(): void {
    this.isOpen.set(!this.isOpen());
    // Refetched on every opening so tenant changes made elsewhere are reflected.
    if (this.isOpen()) this.pagination.reload();
  }

  onSelect(tenant: TenantDto): void {
    this.context.selectTenant(tenant);
    this.isOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocClick(event: MouseEvent): void {
    const target = event.target as Node | null;
    if (!target) return;
    if (!this.elementRef.nativeElement.contains(target)) {
      this.isOpen.set(false);
    }
  }
}
